import {capitalize, map} from 'lodash';

export default function getCapitalizedName(productName) {

  //some products have names consisting of numbers
  const titleString = productName.toString();

  const capitalizedWords = map(titleString.split(' '), capitalize);

  return capitalizedWords.join(' ');
}
